import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import mercadoLibreLogo from 'assets/img/logos/mercadolibre45470890.png';

const LOGO_SIZE_MAP = {
  s: 16,
  m: 24,
  l: 32,
  xl: 40,
  '2xl': 48,
  '3xl': 56,
  '4xl': 64,
  '5xl': 72
};

const ProviderAvatar = ({
  provider,
  size,
  className,
  rounded,
  showFallbackIcon
}) => {
  const normalizedProvider = String(provider || '').toUpperCase();

  if (normalizedProvider === 'MERCADO_LIBRE' || normalizedProvider === 'MLAPI') {
    const px = LOGO_SIZE_MAP[size] || LOGO_SIZE_MAP.xl;
    return (
      <div className={className} style={{ width: px, height: px, flexShrink: 0 }}>
        <img
          src={mercadoLibreLogo}
          alt="Mercado Libre"
          style={{ width: px, height: px, objectFit: 'contain' }}
        />
      </div>
    );
  }

  return (
    <div className={className}>
      <Avatar
        size={size}
        rounded={rounded}
        icon={showFallbackIcon ? 'plug' : undefined}
        name={!showFallbackIcon ? 'IN' : undefined}
        isExact={!showFallbackIcon}
        mediaClass="integration-provider-avatar integration-provider-avatar-default fw-bold"
      />
    </div>
  );
};

ProviderAvatar.propTypes = {
  provider: PropTypes.string,
  size: PropTypes.oneOf(['s', 'm', 'l', 'xl', '2xl', '3xl', '4xl', '5xl']),
  className: PropTypes.string,
  rounded: PropTypes.string,
  showFallbackIcon: PropTypes.bool
};

ProviderAvatar.defaultProps = {
  provider: '',
  size: 'xl',
  className: '',
  rounded: 'circle',
  showFallbackIcon: true
};

export default ProviderAvatar;
